"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.01677 10.5944C1.90328 10.4147 1.84653 10.3248 1.81477 10.1862C1.79091 10.0821 1.79091 9.91798 1.81477 9.81388C1.84653 9.6753 1.90328 9.58545 2.01677 9.40575C2.9546 7.92077 5.74615 4.16675 10.0003 4.16675C14.2545 4.16675 17.046 7.92077 17.9839 9.40575C18.0973 9.58545 18.1541 9.6753 18.1859 9.81388C18.2097 9.91798 18.2097 10.0821 18.1859 10.1862C18.1541 10.3248 18.0973 10.4147 17.9839 10.5944C17.046 12.0794 14.2545 15.8334 10.0003 15.8334C5.74615 15.8334 2.9546 12.0794 2.01677 10.5944Z",
    stroke: fill,
    strokeWidth: "1.66666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.0003 12.5001C11.381 12.5001 12.5003 11.3808 12.5003 10.0001C12.5003 8.61936 11.381 7.50007 10.0003 7.50007C8.6196 7.50007 7.50032 8.61936 7.50032 10.0001C7.50032 11.3808 8.6196 12.5001 10.0003 12.5001Z",
    stroke: fill,
    strokeWidth: "1.66666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;